export default "__VITE_ASSET__BYqBXN4t__"